module.exports = __webpack_public_path__ + "img/icon-additional.0cc9f660.svg";